export default __webpack_public_path__ + "maps-guides-markers-annotations-1200-019861e11652d7ae7af41f365ddab7a5.png";